// extracted by mini-css-extract-plugin
module.exports = {"resultsSection":"styles_resultsSection__ugdKL","searchTerms":"styles_searchTerms__3JsbW","noResultsFound":"styles_noResultsFound__1CNUi"};